import LevelUp from "./LevelUp";
import Graduate from "./Graduate";

export default {
  LevelUp,
  Graduate,
};
